import { createContext, useContext } from "react";

export const SidebarContext = createContext({
  sidebarOpen: false,
  setSidebarOpen: () => {},
});

export const useSidebar = () => useContext(SidebarContext);